import { STANDINGORDER_API } from "../constants/api";
import { GetTraderParamModel } from "../model/common";
import {
  getHeadersWithTokenAndTraderId,
  getUrl,
  optionsGet,
  optionsPost,
} from "./commonService";
import customAxios from "./customAxios";

export default class StandingOrderService {
  getStandingOrderDetailsService(params: any) {
    let api = STANDINGORDER_API.GET_DETAILS;
    api = api.replace("#ADDRESSID#", params.addressId);

    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  saveStandingOrdersService(params: any) {
    const url = getUrl(STANDINGORDER_API.SAVE_SO);

    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsPost(url, headers, params.details);

    return customAxios(options).then((res) => {
      // console.log(res);
      return res.data;
    });
  }
}
